import { render, staticRenderFns } from "./secret-auth.vue?vue&type=template&id=503a4027&scoped=true&"
import script from "./secret-auth.vue?vue&type=script&lang=js&"
export * from "./secret-auth.vue?vue&type=script&lang=js&"
import style0 from "./secret-auth.vue?vue&type=style&index=0&id=503a4027&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a4027",
  null
  
)

export default component.exports